import { createAction, props } from '@ngrx/store';
import { StoreConstants } from '../constants/store-constants';
import { TestletConfiguration } from '../models/assessment-models';

export const getInitialAssessment = createAction(
  `[${StoreConstants.STORE_KEY}] get initial assessment`,
  props<{ orgId: string; campaignId: string; assessmentId: number; invitationCode: string }>(),
);

export const getInitialAssessmentSuccess = createAction(
  `[${StoreConstants.STORE_KEY}] get initial assessment success`,
  props<{ testletConfig: TestletConfiguration }>(),
);

export const getInitialAssessmentFailure = createAction(
  `[${StoreConstants.STORE_KEY}] get initial assessment failure`,
  props<{ error: any }>(),
);

export const updateAssessment = createAction(
  `[${StoreConstants.STORE_KEY}] update assessment`,
  props<{
    orgId: string;
    campaignId: string;
    assessmentId: number;
    invitationCode: string;
    currentTestlet: string;
    sessionId: string;
    score: number;
    duration: number;
  }>(),
);

export const updateAssessmentSuccess = createAction(
  `[${StoreConstants.STORE_KEY}] update assessment success`,
  props<{ testletConfig: TestletConfiguration }>(),
);

export const updateAssessmentFailure = createAction(
  `[${StoreConstants.STORE_KEY}] update assessment failure`,
  props<{ error: any }>(),
);

export const setAssessment = createAction(
  `${StoreConstants.STORE_KEY} Set assessment`,
  props<{ assessmentId: number }>(),
);
